export default "__VITE_ASSET__gOnhRr7f__"